// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"title_titleContainer__xkevN","title":"title_title__dFpkQ","more":"title_more__9EHdJ"};